import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import Alert from "@mui/material/Alert";
import Add from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { useRoleList } from "./useRoleList";
import { RoleDataGrid } from "./RoleDataGrid";
import { IfPermission } from "../../auth/IfPermission";

export function RoleList() {
  const navigate = useNavigate();
  const { state, fetching, refetch } = useRoleList();

  return (
    <Box sx={{ p: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5">Роли</Typography>
        <IfPermission permission="roles.create">
          <Button variant="contained" startIcon={<Add />} onClick={() => {
      void navigate("/roles/create");
    }}>
            Создать роль
          </Button>
        </IfPermission>
      </Box>

      {fetching && state.kind !== "loading" ? <LinearProgress sx={{ mb: 1 }} /> : null}

      {state.kind === "loading" ? (
        <Box display="flex" justifyContent="center" p={4}>
          <CircularProgress />
        </Box>
      ) : null}

      {state.kind === "error" ? (
        <Alert severity="error" action={<Button onClick={refetch}>Повторить</Button>}>
          Не удалось загрузить роли: {state.message}
        </Alert>
      ) : null}

      {state.kind === "empty" ? <Typography color="text.secondary">Роли не найдены.</Typography> : null}

      {state.kind === "data" ? (
        <RoleDataGrid items={state.items} onEdit={(role) => {
      void navigate(`/roles/${role.id}`);
    }} />
      ) : null}
    </Box>
  );
}
